import { render, staticRenderFns } from "./FamilySearch.vue?vue&type=template&id=7cd10126&scoped=true&"
import script from "./FamilySearch.vue?vue&type=script&lang=ts&"
export * from "./FamilySearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd10126",
  null
  
)

export default component.exports